import { Direction } from "@/generated/TradingGateway"

const BASE_INSTRUMENT_PAGE_LOCATORS = "InstrumentPageLocators"

export const INSTRUMENT_PAGE_LOCATORS = {
  root: `${BASE_INSTRUMENT_PAGE_LOCATORS}`,
  main: `${BASE_INSTRUMENT_PAGE_LOCATORS}.main`,
  icon: `${BASE_INSTRUMENT_PAGE_LOCATORS}.icon`,
  displayName: `${BASE_INSTRUMENT_PAGE_LOCATORS}.displayName`,
  price: `${BASE_INSTRUMENT_PAGE_LOCATORS}.price`,
  [Direction.Buy]: `${BASE_INSTRUMENT_PAGE_LOCATORS}.buyButton`,
  [Direction.Sell]: `${BASE_INSTRUMENT_PAGE_LOCATORS}.sellButton`,
}
